import { Box, CardContent, Checkbox } from '@mui/material'
import Paragraph from '../../../../shared/UI/Paragraph'

interface Props {
  manAuthAlertChecked: boolean
  onChange: (checked: boolean) => void
}

function RTWPendingManAuthConfirmation({ manAuthAlertChecked, onChange }: Props) {
  return (
    <Box
      sx={{
        backgroundColor: '#FDFDFD',
        borderRadius: '16px',
        padding: '12px 16px',
        opacity: '1',
        border: '0.5px solid rgba(0, 0, 0, 0.16)',
        boxSizing: 'border-box',
        marginTop: '16px',
        display: 'flex',
        alignItems: 'flex-start',
      }}
    >
      <CardContent sx={{ padding: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'centre' }}>
          <Checkbox
            checked={manAuthAlertChecked}
            onChange={() => onChange(!manAuthAlertChecked)}
            sx={{
              padding: '0',
              marginRight: '8px',
              marginTop: '2px',
            }}
          />
          <Box>
            <Paragraph weight="bold" size="13px" sx={{ marginBottom: '4px' }}>
              Discretionary Pay Cancellation Confirmation
            </Paragraph>
            <Paragraph size="13px" sx={{ color: '#000000' }}>
              Submitting the RTW for this absence will cancel these requests and the employee will
              not receive payment for these hours.
            </Paragraph>
          </Box>
        </Box>
      </CardContent>
    </Box>
  )
}

export default RTWPendingManAuthConfirmation
